import React, { useEffect } from "react";
import getTotalCost from "../../../../actions/getTotalCost";
import { useBusinessContext } from "../../../../context/business";

export default function TotalCost() {
  const {
    businessData: { businessData },
    selectedBusiness,
    setSelectedBusiness,
  } = useBusinessContext();

  useEffect(() => {
    //get total cost
    if (selectedBusiness.services.length > 0) {
      const isGroupSession = selectedBusiness.services[0]?.is_group_session;
      const quantity = isGroupSession ? (selectedBusiness.services[0]?.quantity || 1) : undefined;
      getTotalCost({
        businessID: businessData.identifier,
        body: {
          discount: selectedBusiness?.discount, // Add discount code to the request body
          services: selectedBusiness.services,
          quantity,
          type: businessData.accepts_payment ? "paid" : "free",
        },
      }).then(({ data: { data } }) => {
        setSelectedBusiness({ type: "FETCH_TOTAL_COST", data });
      });
    } else {
      // Reset total cost when no services are selected
      setSelectedBusiness({ type: "RESET_TOTAL_COST" });
    }
  }, [
    selectedBusiness.discount,
    selectedBusiness.services,
    businessData.accepts_payment,
    businessData.identifier,
    setSelectedBusiness,
  ]);
  return <span />;
}
